module.exports = __webpack_public_path__ + "img/gu.eb9a1c61.svg";